import { useSite } from "../lib/site";

const Star = () => (
  <svg viewBox="0 0 20 20" className="w-5 h-5 sm:w-7 sm:h-7 shrink-0 text-[var(--gold)]" aria-hidden="true">
    <path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" />
  </svg>
);

export const Marquee = () => {
  const { t } = useSite();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y border-[var(--line)] py-8 sm:py-10 overflow-hidden" dir="ltr" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={i} className="flex items-center gap-10 px-5 sm:px-8">
                <span className={`f-display text-4xl sm:text-6xl lg:text-7xl whitespace-nowrap ${i % 2 ? "outline-text italic rtl:not-italic" : "text-[var(--sand)]"}`}>{w}</span>
                <Star />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
